import { useMemo, useState } from 'react'
import MovimentacaoLastMileHttp from '../../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_PRESTACOES: 'Adquirindo dados',
  SUCCESS: 'SUCCESS',
}

const INITIAL_MOV = {
  ativo_name: '',
  qte_delivery: '',
  qte_fisico: '',
  qte_canhoto: '',
}

const INITIAL_STATE = {
  selectedMovimentacao: [{ ...INITIAL_MOV }],
  prestacoes: {},
  data: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const STATUS_CANHOTO = {
  PENDENTE: 'Pendente',
  OK: 'OK',
  RECUSADO: 'Recusado',
}

export default function useModalResumoPrestacaoContas() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getPrestacoesContas(movimentacao_last_mile_id) {
        MovimentacaoLastMileHttp.getPrestacoesContas(movimentacao_last_mile_id)
          .then(prestacoesContas => {
            setState(prevState => ({
              ...prevState,
              prestacoes: prestacoesContas,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      buildData(ativos, prestacoes) {
        const dataBuilded = []

        ativos.forEach(ativo => {
          let fisicoTotal = 0
          let canhotoTotal = 0
          prestacoes.forEach(prestacao => {
            const fisico = prestacao.ativos.filter(a => a.patrimonio_ativo_id === ativo.ativo_id)
            fisicoTotal += fisico.map(f => f.qte).reduce((acc, curr) => acc + curr, 0)

            const canhoto = prestacao.canhotos.filter(
              c => c.patrimonio_ativo_id === ativo.ativo_id && c.status !== STATUS_CANHOTO.RECUSADO,
            )
            canhotoTotal += canhoto.map(c => c.qte).reduce((acc, curr) => acc + curr, 0)
          })
          dataBuilded.push({
            ativo_name: ativo.ativo_name,
            qte_delivery: ativo.qte,
            qte_fisico: fisicoTotal,
            qte_canhoto: canhotoTotal,
          })
        })

        setState(prevState => ({ ...prevState, data: dataBuilded }))
      },

      //Events
      onInit(data) {
        setState(prevState => ({
          ...prevState,
          selectedMovimentacao: data,
          loadingMessage: LOAD_MESSAGE.GET_PRESTACOES,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
